<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>
                    <div class="content">
                        <div class="classTypesSelect">
                            选择继续教育学年:
                            <el-select v-model="year_value" placeholder="请选择" @change="yearChange">
                                <el-option v-for="item in year" :key="item.year" :label="item.year" :value="item.year">
                                </el-option>
                            </el-select>
                        </div>

                        <div class="classTypesTab">

                            <p v-for="(item, idx) in classTypesTabData" :key="idx" :class="{'active':activeIdx === idx}"
                                @click="classTypesTabEvent(idx)">
                                {{item.title}}</p>
                        </div>

                        <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" class="listTable">
                            <el-table-column align="center" prop="create_time" label="开始时间">
                            </el-table-column>
                            <el-table-column align="center" prop="is_post" label="是否交卷">
                                <template slot-scope="scope">
                                    {{ scope.row.is_post == 1 ? '未交卷' : '已交卷' }}
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="num" label="试题数量">
                            </el-table-column>
                            <el-table-column align="center" prop="is_post" label="操作">
                                <template slot-scope="scope">
                                    <el-button class="signUpNowBtn startBtn contiueExam" @click="contiueExam(scope.row.pid)"
                                        v-if='scope.row.is_post == 1'>继续考试</el-button>
                                    <el-button class="signUpNowBtn startBtn contiueExam" @click="lookExam(scope.row.pid)"
                                        v-if='scope.row.is_post == 2'>查看</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination background @current-change="handleCurrentChange" layout="prev, pager, next" :total="total">
                        </el-pagination>
                        <el-button class="signUpNowBtn startBtn" @click="startExam" v-show='!loading'>开始练习</el-button>
                        <!-- <p class="active" @click="classTypesTabEvent(idx)">开始模考</p> -->
                    </div>

                </section>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import commonheader from "../../common/commonHeader.vue"; //头部组件
import leftMenu from "../../common/leftMenu.vue";
import exit from "../../common/exit.vue";
import examheader from "./examHeader.vue";
export default {
    name: 'index',
    components: {
        commonheader,
        leftMenu,
        exit,
        examheader
    },
    data () {
        return {
            loading: true,
            year: [],
            year_value: '',

            classTypesTabData: [
                {
                    'title': '网授课程'
                },
                {
                    'title': '面授课程'
                }
            ],
            activeIdx: 0,

            tableData: [],
            total:0,
            page:1
        }
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";
        this.getYear();
    },
    methods: {
        /**
         * 获取年份
         */
        getYear () {
            this.$store.dispatch('academic_year', {}).then((res) => {
                if( res.data.length ){
                    this.year = res.data;
                    this.year_value = res.data[0].year;
                    this.getExamList();
                }else{
                    this.loading = false;
                }
            })
        },
        /**
         * 获取试卷列表
         * year  年份
         * type  教育类型： 1 网授 2 面授
         */
        getExamList () {
            let params = {
                year: this.year_value,
                type: this.activeIdx + 1,
                page: this.page
            }
            console.log(params)
            this.$store.dispatch('exam_lists', params).then((res) => {
                this.loading = false;
                this.tableData = res.data.data;
                this.total = res.data.total;
            }).catch(error => {
                this.loading = false;
            })
        },
        /**
         * 开始模考
         */
        startExam () {
            if( !this.year_value ){
                this.$message({
                    type:'error',
                    message:'没有选择当年度的课程'
                })
                return false;
            }

            this.$router.push({
                name:'exam',
                query: {
                    year: this.year_value,
                    type: this.activeIdx + 1,
                }
            });
        },
        /**
         * 继续考试
         */
        contiueExam (pid) {
            this.$router.push({
                name:'exam',
                query: {
                    pid:pid,
                    year: this.year_value,
                    type: this.activeIdx + 1,
                }
            });
        },
        /**
         * 查看考试
         */
        lookExam (pid) {
            this.$router.push({
                name:'exam',
                query: {
                    pid:pid,
                    look:true
                }
            });
        },

        /**
         * 分页
         */
        handleCurrentChange(param){
            this.page = param;
            this.loading = true;
            this.getExamList();
        },
        classTypesTabEvent (idx) {
            if (idx == 1) {
                this.$message('暂未开放');
                return false;
            }
            this.activeIdx = idx
        },
        yearChange () {
            this.getExamList();
        },
        typeChange () {

        }
    }
}
</script>

<style lang="stylus" scoped>
@media (min-width: 1399px)
    .el-container-master
        width 1400px
        margin auto
.el-aside
    background #fff
.el-main
    padding 0
    background #fff
.content
    padding 47px 32px 29px 40px
    flex 1
    border-top 10px solid #F8F8F8
    border-left 10px solid #F8F8F8
    padding-bottom 50px
    position relative
    .el-pagination
        text-align center
        margin-top 20px
    .qesType
        position relative
        text-align center
        margin 30px 0 50px
        .qesTypeText
            color $textColorGray
            font-size 18px
        .qesNum
            color $textColorGray
            font-scale 14px
            position absolute
            right 10px
            top 0
    .title
        margin-bottom 50px
    .listTable
        margin-top 60px
        text-align center
    .startBtn
        width 290px
        height 40px
        color $textColorBlue
        border 1px solid $textColorBlue
        display block
        margin 30px auto
        font-weight normal
    .contiueExam
        width auto
        height auto
        margin 0
        display inline-block
        font-weight normal
    .btnGroup
        width 385px
        line-height 26px
        padding 16px 0
        cursor pointer
        z-index 5
        position fixed
        left 0
        right 0
        bottom 47px
        margin auto
        transform translateX(110px)
        background-image url('~@/assets/images/examBtnBg.png')
        background-size 100% 100%
        span
            width 120px
            font-size 16px
            text-align center
            color $textColorGray
            border-right 1px solid #D1D1D1
            display inline-block
            &:last-child
                border-right 0
        .active
            color #333333
.classTypesTab, .onlineConfirmSignUpBtns
    overflow hidden
    margin 0 auto
    text-align center
.classTypesTab > p
    display inline-block
    margin 0 35px
    width 110px
    height 38px
    line-height 38px
    text-align center
    color #0173ff
    font-size 16px
    letter-spacing 2px
    border 1px solid #43affc
    border-radius 4px
    cursor pointer
.classTypesSelect .el-select{
    width: 100px;
}
.classTypesSelect
    position absolute
    left 86px
    top 47px
.classTypesTab > p.active
    background-image -webkit-linear-gradient(left, #4bb7fc, #0173ff)
    background-image -o-linear-gradient(left, #4bb7fc, #0173ff)
    background-image -ms-linear-gradient(left, #4bb7fc, #0173ff)
    background-image linear-gradient(left, #4bb7fc, #0173ff)
    color #fff
    border none
</style>



// WEBPACK FOOTER //
// src/components/my/exam/lists.vue